// please keep this sorted alphabetically
import AnnualGrossIncome from "./annual-gross-income/AnnualGrossIncome";
import Birthdate from "./birthdate/Birthdate";
import BirthdateWithInputFields from "./birthdate-with-inputfields/BirthdateWithInputFields";
import ConfiguredDate from "./configured-date/ConfiguredDate";
import ContinueButton from "./continue-button/ContinueButton";
import DeviceFingerprint from "./device-fingerprint/DeviceFingerprint";
import Disclosures from "./disclosures/Disclosures";
import * as disclosuresRedux from "./disclosures/redux";
import Email from "./email/Email";
import EmailWithConfirmation from "./email-with-confirmation/EmailWithConfirmation";
import EmployerName from "./employer-name/EmployerName";
import EmploymentStatus from "./employment-status/EmploymentStatus";
import LoanAmount from "./loan-amount/LoanAmount";
import LoanAmountSelect from "./loan-amount-select/LoanAmountSelect";
import PaymentAmount from "./payment-amount/PaymentAmount";
import PhoneNumber from "./phone-number/PhoneNumber";
import Recaptcha from "./recaptcha/Recaptcha";
import SocialSecurity from "./social-security/SocialSecurity";
// please keep this sorted alphabetically

// Export both components and their redux modules
const components = {
  redux: {
    disclosures: disclosuresRedux
  },
  AnnualGrossIncome,
  Birthdate,
  BirthdateWithInputFields,
  ConfiguredDate,
  ContinueButton,
  DeviceFingerprint,
  Disclosures,
  Email,
  EmailWithConfirmation,
  EmployerName,
  EmploymentStatus,
  LoanAmount,
  LoanAmountSelect,
  PaymentAmount,
  PhoneNumber,
  Recaptcha,
  SocialSecurity
};

export default components;
